import { lazy } from 'react'
import { STEP } from '../constants/steps'

// Sections A-J share one shape: they edit one slice of formData and have a
// fixed neighbour on each side. Documents (L), review, signature (K) and the
// finish screen take different props and are wired by hand in App.
//
//   reviewEdit  - the section is also opened from the review screen and gets
//                 `isReviewEdit` to relabel its "next" button
//   usesSetStep - the section can jump over others (E skips F-J for SGB XII)
export const DATA_SECTIONS = [
	{
		step: STEP.A,
		key: 'sectionA',
		prev: STEP.START,
		next: STEP.B,
		Component: lazy(() => import('../components/SectionA.jsx')),
	},
	{
		step: STEP.B,
		key: 'sectionB',
		prev: STEP.A,
		next: STEP.C,
		Component: lazy(() => import('../components/SectionB.jsx')),
	},
	{
		step: STEP.C,
		key: 'sectionC',
		prev: STEP.B,
		next: STEP.D,
		Component: lazy(() => import('../components/SectionC.jsx')),
	},
	{
		step: STEP.D,
		key: 'sectionD',
		prev: STEP.C,
		next: STEP.E,
		reviewEdit: true,
		Component: lazy(() => import('../components/SectionD/SectionD.jsx')),
	},
	{
		step: STEP.E,
		key: 'sectionE',
		prev: STEP.D,
		next: STEP.F,
		usesSetStep: true,
		Component: lazy(() => import('../components/SectionE/SectionE.jsx')),
	},
	{
		step: STEP.F,
		key: 'sectionF',
		prev: STEP.E,
		next: STEP.G,
		Component: lazy(() => import('../components/SectionF.jsx')),
	},
	{
		step: STEP.G,
		key: 'sectionG',
		prev: STEP.F,
		next: STEP.H,
		reviewEdit: true,
		Component: lazy(() => import('../components/SectionG.jsx')),
	},
	{
		step: STEP.H,
		key: 'sectionH',
		prev: STEP.G,
		next: STEP.I,
		Component: lazy(() => import('../components/SectionH.jsx')),
	},
	{
		step: STEP.I,
		key: 'sectionI',
		prev: STEP.H,
		next: STEP.J,
		reviewEdit: true,
		Component: lazy(() => import('../components/SectionI.jsx')),
	},
	{
		step: STEP.J,
		key: 'sectionJ',
		prev: STEP.I,
		next: STEP.L,
		reviewEdit: true,
		Component: lazy(() => import('../components/SectionJ.jsx')),
	},
]

export const findDataSection = step => DATA_SECTIONS.find(section => section.step === step)
